export default {
  name: 'United States',
  phonePattern: '12015550123',
  postalCodePattern: '111111111',
  singlePostalCode: '',
  postalCodeRegex: '^([\\d]{5}|[\\d]{9})$',
  language: '',
  dobFormat: 'MM/DD/YY',
  provinces: [{
    name: 'Alabama',
    ISOCode: 'US-AL',
    postcodeRanges: [{
      min: '35001',
      max: '35299'
    }, {
      min: '35401',
      max: '36999'
    }]
  }, {
    name: 'Alaska',
    ISOCode: 'US-AK',
    postcodeRanges: [{
      min: '99501',
      max: '99999'
    }]
  }, {
    name: 'Arizona',
    ISOCode: 'US-AZ',
    postcodeRanges: [{
      min: '85001',
      max: '85399'
    }, {
      min: '85501',
      max: '85799'
    }, {
      min: '85901',
      max: '86099'
    }, {
      min: '86301',
      max: '86599'
    }]
  }, {
    name: 'Arkansas',
    ISOCode: 'US-AR',
    postcodeRanges: [{
      min: '71601',
      max: '72999'
    }]
  }, {
    name: 'California',
    ISOCode: 'US-CA',
    postcodeRanges: [{
      min: '90001',
      max: '90899'
    }, {
      min: '91001',
      max: '92899'
    }, {
      min: '93001',
      max: '96199'
    }]
  }, {
    name: 'Colorado',
    ISOCode: 'US-CO',
    postcodeRanges: [{
      min: '80001',
      max: '81699'
    }]
  }, {
    name: 'Connecticut',
    ISOCode: 'US-CT',
    postcodeRanges: [{
      min: '06001',
      max: '06389'
    }, {
      min: '06391',
      max: '06999'
    }]
  }, {
    name: 'Delaware',
    ISOCode: 'US-DE',
    postcodeRanges: [{
      min: '19701',
      max: '19999'
    }]
  }, {
    name: 'District of Columbia',
    ISOCode: 'US-DC',
    postcodeRanges: [{
      min: '20001',
      max: '20099'
    }, {
      min: '20201',
      max: '20587'
    }, {
      min: '56901',
      max: '56999'
    }, {
      min: '20589',
      max: '20597'
    }, {
      min: '20599',
      max: '20599'
    }]
  }, {
    name: 'Florida',
    ISOCode: 'US-FL',
    postcodeRanges: [{
      min: '32001',
      max: '33999'
    }, {
      min: '34101',
      max: '34199'
    }, {
      min: '34201',
      max: '34299'
    }, {
      min: '34401',
      max: '34499'
    }, {
      min: '34601',
      max: '34699'
    }, {
      min: '34701',
      max: '34799'
    }, {
      min: '34901',
      max: '34999'
    }]
  }, {
    name: 'Georgia',
    ISOCode: 'US-GA',
    postcodeRanges: [{
      min: '30001',
      max: '31999'
    }, {
      min: '39801',
      max: '39999'
    }]
  }, {
    name: 'Hawaii',
    ISOCode: 'US-HI',
    postcodeRanges: [{
      min: '96701',
      max: '96798'
    }, {
      min: '96801',
      max: '96899'
    }]
  }, {
    name: 'Idaho',
    ISOCode: 'US-ID',
    postcodeRanges: [{
      min: '83201',
      max: '83413'
    }, {
      min: '83415',
      max: '83899'
    }]
  }, {
    name: 'Illinois',
    ISOCode: 'US-IL',
    postcodeRanges: [{
      min: '60001',
      max: '62099'
    }, {
      min: '62201',
      max: '62999'
    }]
  }, {
    name: 'Indiana',
    ISOCode: 'US-IN',
    postcodeRanges: [{
      min: '46001',
      max: '47999'
    }]
  }, {
    name: 'Iowa',
    ISOCode: 'US-IA',
    postcodeRanges: [{
      min: '50001',
      max: '51699'
    }, {
      min: '52001',
      max: '52899'
    }]
  }, {
    name: 'Kansas',
    ISOCode: 'US-KS',
    postcodeRanges: [{
      min: '66001',
      max: '66299'
    }, {
      min: '66401',
      max: '67999'
    }]
  }, {
    name: 'Kentucky',
    ISOCode: 'US-KY',
    postcodeRanges: [{
      min: '40001',
      max: '41899'
    }, {
      min: '42001',
      max: '42799'
    }]
  }, {
    name: 'Louisiana',
    ISOCode: 'US-LA',
    postcodeRanges: [{
      min: '70001',
      max: '70199'
    }, {
      min: '70301',
      max: '70899'
    }, {
      min: '71001',
      max: '71499'
    }]
  }, {
    name: 'Maine',
    ISOCode: 'US-ME',
    postcodeRanges: [{
      min: '03901',
      max: '04999'
    }]
  }, {
    name: 'Maryland',
    ISOCode: 'US-MD',
    postcodeRanges: [{
      min: '20588',
      max: '20588'
    }, {
      min: '20601',
      max: '21299'
    }, {
      min: '201401',
      max: '21999'
    }]
  }, {
    name: 'Massachusetts',
    ISOCode: 'US-MA',
    postcodeRanges: [{
      min: '01001',
      max: '02799'
    }, {
      min: '05501',
      max: '05599'
    }]
  }, {
    name: 'Michigan',
    ISOCode: 'US-MI',
    postcodeRanges: [{
      min: '03901',
      max: '04999'
    }]
  }, {
    name: 'Minnesota',
    ISOCode: 'US-MN',
    postcodeRanges: [{
      min: '55001',
      max: '55199'
    }, {
      min: '55301',
      max: '56799'
    }]
  }, {
    name: 'Mississippi',
    ISOCode: 'US-MS',
    postcodeRanges: [{
      min: '38601',
      max: '39799'
    }]
  }, {
    name: 'Missouri',
    ISOCode: 'US-MO',
    postcodeRanges: [{
      min: '63001',
      max: '68199'
    }, {
      min: '63301',
      max: '64199'
    }, {
      min: '64401',
      max: '65899'
    }]
  }, {
    name: 'Montana',
    ISOCode: 'US-MT',
    postcodeRanges: [{
      min: '59001',
      max: '59999'
    }]
  }, {
    name: 'Nebraska',
    ISOCode: 'US-NE',
    postcodeRanges: [{
      min: '68001',
      max: '68199'
    }, {
      min: '68301',
      max: '69399'
    }]
  }, {
    name: 'Nevada',
    ISOCode: 'US-NV',
    postcodeRanges: [{
      min: '88901',
      max: '89199'
    }, {
      min: '89301',
      max: '89599'
    }, {
      min: '89701',
      max: '89899'
    }]
  }, {
    name: 'New Hampshire',
    ISOCode: 'US-NH',
    postcodeRanges: [{
      min: '03001',
      max: '03899'
    }]
  }, {
    name: 'New Jersey',
    ISOCode: 'US-NJ',
    postcodeRanges: [{
      min: '07001',
      max: '08999'
    }]
  }, {
    name: 'New Mexico',
    ISOCode: 'US-NM',
    postcodeRanges: [{
      min: '87001',
      max: '087199'
    }]
  }, {
    name: 'New York',
    ISOCode: 'US-NY',
    postcodeRanges: [{
      min: '00501',
      max: '06390'
    }, {
      min: '10001',
      max: '14999'
    }]
  }, {
    name: 'North Carolina',
    ISOCode: 'US-NC',
    postcodeRanges: [{
      min: '27001',
      max: '28999'
    }]
  }, {
    name: 'North Dakota',
    ISOCode: 'US-ND',
    postcodeRanges: [{
      min: '58001',
      max: '58899'
    }]
  }, {
    name: 'Ohio',
    ISOCode: 'US-OH',
    postcodeRanges: [{
      min: '43001',
      max: '45999'
    }]
  }, {
    name: 'Oklahoma',
    ISOCode: 'US-OK',
    postcodeRanges: [{
      min: '73001',
      max: '73199'
    }, {
      min: '73401',
      max: '73959'
    }, {
      min: '73961',
      max: '74199'
    }, {
      min: '74301',
      max: '74999'
    }]
  }, {
    name: 'Oregon',
    ISOCode: 'US-OR',
    postcodeRanges: [{
      min: '97001',
      max: '97099'
    }]
  }, {
    name: 'Pennsylvania',
    ISOCode: 'US-PA',
    postcodeRanges: [{
      min: '15001',
      max: '19699'
    }]
  }, {
    name: 'Rhode Island',
    ISOCode: 'US-RI',
    postcodeRanges: [{
      min: '02801',
      max: '02899'
    }, {
      min: '02901',
      max: '02999'
    }]
  }, {
    name: 'South Carolina',
    ISOCode: 'US-SC',
    postcodeRanges: [{
      min: '29001',
      max: '29999'
    }]
  }, {
    name: 'South Dakota',
    ISOCode: 'US-SD',
    postcodeRanges: [{
      min: '57001',
      max: '57799'
    }]
  }, {
    name: 'Tennessee',
    ISOCode: 'US-TN',
    postcodeRanges: [{
      min: '37001',
      max: '37099'
    }]
  }, {
    name: 'Texas',
    ISOCode: 'US-TX',
    postcodeRanges: [{
      min: '73301',
      max: '73399'
    }, {
      min: '73960',
      max: '73960'
    }, {
      min: '75001',
      max: '77099'
    }, {
      min: '77201',
      max: '79999'
    }, {
      min: '88501',
      max: '88599'
    }]
  }, {
    name: 'Utah',
    ISOCode: 'US-UT',
    postcodeRanges: {
      min: '84001',
      max: '84799'
    }
  }, {
    name: 'Vermont',
    ISOCode: 'US-VT',
    postcodeRanges: [{
      min: '05001',
      max: '05499'
    }, {
      min: '05601',
      max: '05999'
    }]
  }, {
    name: 'Virginia',
    ISOCode: 'US-VA',
    postcodeRanges: [{
      min: '20101',
      max: '20199'
    }, {
      min: '20598',
      max: '20598'
    }, {
      min: '22001',
      max: '24699'
    }]
  }, {
    name: 'Washington',
    ISOCode: 'US-WA',
    postcodeRanges: [{
      min: '98001',
      max: '98699'
    }, {
      min: '98801',
      max: '99499'
    }]
  }, {
    name: 'West Virginia',
    ISOCode: 'US-WV',
    postcodeRanges: [{
      min: '24701',
      max: '26899'
    }]
  }, {
    name: 'Wisconsin',
    ISOCode: 'US-WI',
    postcodeRanges: [{
      min: '53001',
      max: '53299'
    }, {
      min: '53401',
      max: '53599'
    }, {
      min: '53701',
      max: '54999'
    }]
  }, {
    name: 'Wyoming',
    ISOCode: 'US-WY',
    postcodeRanges: [{
      min: '82001',
      max: '83199'
    }, {
      min: '83414',
      max: '83414'
    }]
  }],
  currency: 'usd'
}



// WEBPACK FOOTER //
// ./src/locales/countries/US.js